<div class="tooltip-container" [ngClass]="config.tooltipClass ?? ''">
    <ng-template #vc></ng-template>

    <ng-container *ngIf="!isComponent">
        <ng-container *ngIf="config.allowHtml; else baseTextContent">
            <div [innerHTML]="renderedContent"></div>
        </ng-container>

        <ng-template #baseTextContent>
            <div>{{ renderedContent }}</div>
        </ng-template>
    </ng-container>
</div>